import React from 'react';
import { X, ChevronLeft, ChevronRight, Download } from 'lucide-react';

const LightboxModal = ({ isOpen, images, activeIndex, onClose, onPrev, onNext }) => {
    const [shouldRender, setShouldRender] = React.useState(isOpen);
    const [isAnimatingOut, setIsAnimatingOut] = React.useState(false);

    React.useEffect(() => {
        if (isOpen) {
            setShouldRender(true);
            setIsAnimatingOut(false);
        } else if (shouldRender) {
            setIsAnimatingOut(true);
            const timer = setTimeout(() => {
                setShouldRender(false);
                setIsAnimatingOut(false);
            }, 300);
            return () => clearTimeout(timer);
        }
    }, [isOpen, shouldRender]);

    if (!shouldRender || !images || images.length === 0) return null;

    const currentImage = images[activeIndex];

    return (
        <div className="fixed inset-0 z-[110] flex items-center justify-center p-4 md:p-10">
            {/* Backdrop */}
            <div
                className={`absolute inset-0 bg-black/95 backdrop-blur-3xl transition-opacity duration-300 ${isAnimatingOut ? 'animate-fadeOut' : 'animate-fadeIn'
                    }`}
                onClick={onClose}
            />

            {/* Close Button */}
            <button
                onClick={onClose}
                className={`absolute top-8 right-8 z-[120] p-4 rounded-full bg-white/10 hover:bg-white/20 text-white transition-all hover:rotate-90 shadow-2xl ${isAnimatingOut ? 'animate-zoomOut' : 'animate-zoomIn'
                    }`}
            >
                <X size={32} />
            </button>

            {/* Navigation Buttons */}
            <div className={`contents ${isAnimatingOut ? 'animate-fadeOut' : 'animate-fadeIn'}`}>
                <button
                    onClick={(e) => { e.stopPropagation(); onPrev(); }}
                    className="absolute left-4 md:left-8 z-[120] p-4 rounded-full bg-white/10 hover:bg-white/20 text-white transition-all hover:-translate-x-2 shadow-2xl"
                >
                    <ChevronLeft size={48} />
                </button>

                <button
                    onClick={(e) => { e.stopPropagation(); onNext(); }}
                    className="absolute right-4 md:right-8 z-[120] p-4 rounded-full bg-white/10 hover:bg-white/20 text-white transition-all hover:translate-x-2 shadow-2xl"
                >
                    <ChevronRight size={48} />
                </button>
            </div>

            {/* Image Container */}
            <div className={`relative w-full h-full flex items-center justify-center pointer-events-none ${isAnimatingOut ? 'animate-zoomOut' : 'animate-zoomIn'
                }`}>
                <img
                    src={currentImage}
                    alt="Current View"
                    className="max-w-full max-h-full object-contain rounded-lg shadow-[0_0_100px_rgba(0,0,0,0.5)] border border-white/10 pointer-events-auto"
                />

                {/* Image Info */}
                <div className="absolute bottom-4 left-1/2 -translate-x-1/2 flex items-center gap-6 px-8 py-4 bg-black/40 backdrop-blur-xl rounded-full border border-white/10 text-white/80 pointer-events-auto">
                    <span className="text-xs font-bold tracking-widest uppercase">
                        {activeIndex + 1} / {images.length}
                    </span>
                    <a
                        href={currentImage}
                        download
                        className="p-2 hover:text-white transition-colors"
                        onClick={(e) => e.stopPropagation()}
                    >
                        <Download size={20} />
                    </a>
                </div>
            </div>

            {/* Backdrop Click */}
            <div className="absolute inset-0 z-[105]" onClick={onClose} />
        </div>
    );
};

export default LightboxModal;
